import { BundlesSelector } from './types';

export const bundlesSelector = (store: BundlesSelector) => store.bundles.data;
